import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {finalize} from 'rxjs';
import {LoadingService} from '@core/services';

const SKIP_LOADER_HEADER = 'X-Skip-Loader';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loading = inject(LoadingService);

  if (req.headers.has(SKIP_LOADER_HEADER)) {
    const cleanHeaders = req.headers.delete(SKIP_LOADER_HEADER);
    return next(req.clone({headers: cleanHeaders}));
  }

  loading.start();
  return next(req).pipe(
    finalize(() => loading.stop())
  );
};
